import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-tpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MapService } from "../../../../../map/shared/map.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationTpamsConstants } from "./create-application-location-tpams.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import Query from "@arcgis/core/rest/support/Query";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { debounceTime } from "rxjs";
import { finalize, take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
let CreateApplicationLocationTpamsComponent = class CreateApplicationLocationTpamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationTpamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationTpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationTpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationTpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationTpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationTpamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationTpamsConstants.ADDRESS_CONTROL;
    buildingUseControl = CreateApplicationLocationTpamsConstants.BUILDING_USE_CONTROL;
    erfSizeControl = CreateApplicationLocationTpamsConstants.ERF_SIZE_CONTROL;
    buildingFloorAreaControl = CreateApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_CONTROL;
    titleDeedControl = CreateApplicationLocationTpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = CreateApplicationLocationTpamsConstants.ZONE_CONTROL;
    ownerControl = CreateApplicationLocationTpamsConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationTpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationTpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationTpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationTpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationTpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationTpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    buildingUseTextPlaceHolder = CreateApplicationLocationTpamsConstants.BUILDING_USE_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationTpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    buildingFloorAreaTextPlaceHolder = CreateApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationTpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationLocationTpamsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationLocationTpamsConstants.ADD_ZONE_LABEL;
    ownerLabel = CreateApplicationLocationTpamsConstants.OWNER_LABEL;
    copyApplicantToOwnerZoneLabel = CreateApplicationLocationTpamsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationTpamsConstants.REMOVE_PROPERTY_LABEL;
    resubmissionMessage = CreateApplicationLocationTpamsConstants.RESUBMISSION_MESSAGE;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owner";
    zones = [];
    mapComponent;
    isMapLoaded = false;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.zones = defaults.zoneOptions;
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("zones")) {
                this.zones = this.aflaModuleStrategyService.lookups.get("zones");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveZoneClicked(propertyIndex, zoneIndex) {
        const controls = this.getZones(propertyIndex);
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked(propertyIndex) {
        const zonesControl = this.getZones(propertyIndex);
        const lastZoneControl = zonesControl.at(zonesControl.length - 1);
        if (lastZoneControl && lastZoneControl.get("zone").value === null) {
            return;
        }
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const previoursActiveIndex = this.active;
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
        if (previoursActiveIndex === propertyIndex && propertyIndex > 0) {
            this.active = propertyIndex - 1;
        }
        else if (previoursActiveIndex > propertyIndex) {
            this.active = previoursActiveIndex - 1;
        }
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        // sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and name eq 'Zoning'`,
        };
        this.createApplicationService.getLookupsObservable(params).pipe(take(1)).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.changeDetectorRefs.detectChanges();
    }
    loadExistingProperty(property) {
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
        const geom = JsonUtils.fromJSON(geometryArc);
        this.getPreviousApplicantData(property, geom);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationTpamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                buildingUse: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "BuildingUse", "buildinguse")),
                erfSize: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfSize", "erfsize "), [Validators.required]),
                buildingFloorArea: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "BuildingFloorArea", "buildingfloorarea"), [Validators.required]),
                titleDeed: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed", "titledeed"), [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required])
            });
            /*       let erfNo = this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfNumber");
                  let farmNo = this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmNumber");
                  if(erfNo !== undefined && erfNo !== null && erfNo.trim() !== ""){
                    newProperty.controls[this.farmNoControl].clearValidators();
                    newProperty.controls[this.subdivisionControl].clearValidators();
                    newProperty.controls[this.erfNoControl].setValidators(Validators.required);
                  }
      
                  if(farmNo !== undefined && farmNo !== null && farmNo.trim() !== ""){
                    newProperty.controls[this.erfNoControl].clearValidators();
                    newProperty.controls[this.farmNoControl].setValidators(Validators.required);
                    newProperty.controls[this.subdivisionControl].setValidators(Validators.required);
                  } */
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1)).subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property zone");
                    if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
                        const zoningLayer = zoningLayerObj.layer;
                        const zoningQuery = new Query();
                        zoningQuery.where = `SgCode = '${sgCode}'`;
                        zoningQuery.returnGeometry = false;
                        zoningQuery.outFields = ["*"];
                        zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                            // Make sure the grave centroid is within one cemetery boundary
                            const zonesControl = newProperty.get("zones");
                            if (zoneFeatureSet.features.length > 0) {
                                zoneFeatureSet.features.forEach(item => {
                                    const zone = this.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                                    if (zone !== undefined && zone != null) {
                                        let foundZone = null;
                                        this.zones.forEach(zoneItem => {
                                            if (zoneItem.value === zone) {
                                                foundZone = zoneItem;
                                            }
                                        });
                                        if (foundZone !== null) {
                                            zonesControl.push(new FormGroup({
                                                zone: new FormControl(foundZone, [Validators.required])
                                            }));
                                        }
                                        else {
                                            this.appController.showMessage(CreateApplicationLocationTpamsConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Warning);
                                            const params = {
                                                moduleId: this.createApplicationService.moduleID, lookupType: "Zoning", lookupList: [zone]
                                            };
                                            this.createApplicationService.sendMissingLookupsEmail(params).subscribe();
                                        }
                                    }
                                    else {
                                        this.appController.showMessage(CreateApplicationLocationTpamsConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                                    }
                                });
                            }
                            if (zonesControl.length === 0) {
                                zonesControl.push(new FormGroup({
                                    zone: new FormControl(null, [Validators.required])
                                }));
                            }
                            this.getPropertyOwners(sgCode, newProperty);
                        }, (zoningError) => {
                            this.appController.showMessage(zoningError.message, AlertType.Error);
                            this.getPropertyOwners(sgCode, newProperty);
                        });
                    }
                    else {
                        this.getPropertyOwners(sgCode, newProperty);
                    }
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                id: 0,
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationTpamsConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Town planning graphics", true);
        }
    }
    subscribeToProperty() {
        if (this.aflaModuleStrategyService.previousApplication !== null) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    getPreviousApplicantData(property, geom) {
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.clear();
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
        const newProperty = new FormGroup({
            erfNo: new FormControl(property.erfNumber, [Validators.required]),
            subdivision: new FormControl(property.subdivision, [Validators.required]),
            allotment: new FormControl(property.allotment, [Validators.required]),
            farmNo: new FormControl(property.farmNumber, [Validators.required]),
            sgCode: new FormControl(property.sgCode, [Validators.required]),
            address: new FormControl(property.address, [Validators.required]),
            buildingUse: new FormControl(property.buildingUse),
            erfSize: new FormControl(property.erfSize, [Validators.required]),
            buildingFloorArea: new FormControl(property.buildingFloorArea, [Validators.required]),
            titleDeed: new FormControl(property.titleDeed, [Validators.required]),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required])
        });
        newProperty.controls.sgCode.disable();
        newProperty.controls.erfNo.disable();
        newProperty.controls.farmNo.disable();
        newProperty.controls.subdivision.disable();
        newProperty.controls.allotment.disable();
        const zonesControl = newProperty.get("zones");
        property.zonings.forEach(zone => {
            this.zones.forEach(zoneOption => {
                if (zoneOption.value === zone.zoning) {
                    const zoneGroup = new FormGroup({
                        id: new FormControl(zone.id),
                        applicationId: new FormControl(zone.applicationId),
                        applicationPropertyId: new FormControl(zone.applicationPropertyId),
                        zone: new FormControl(zoneOption, [Validators.required]),
                        deleted: new FormControl(zone.deleted)
                    });
                    zonesControl.push(zoneGroup);
                }
            });
        });
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        const getTrueCentroid = this.createApplicationService.getTrueCentroid(url, formData).pipe(takeUntil(this._destroy$), take(1)).pipe(finalize(() => {
            getTrueCentroid.unsubscribe();
        })).subscribe({
            next: (response) => {
                newProperty.get("centroid").setValue(response.results[0].value);
                propertyControl.push(newProperty);
                this.changeDetectorRefs.detectChanges();
                const ownersControl = newProperty.get("owners");
                this.recipientListService.setRecipients(property.owners, false, ownersControl);
                this.updateRequiredFields(0);
                this.changeDetectorRefs.detectChanges();
                if (this.isMapLoaded) {
                    this.syncMapGeometries();
                }
                this.active = 0;
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationTpamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationTpamsComponent);
export { CreateApplicationLocationTpamsComponent };
